<div class="container mt-5">
    <h1 class="text-center">Trợ Giúp & Tài Liệu</h1>
    <p class="lead text-center">Nguồn tài nguyên của bạn để hiểu rõ ứng dụng của chúng tôi.</p>

    <div class="row mt-4">
        <div class="col-md-4">
            <div class="card">
                <div class="card-header bg-primary text-white">
                    Bắt Đầu
                </div>
                <div class="card-body">
                    <p class="card-text">Tìm hiểu cách thiết lập và sử dụng ứng dụng với hướng dẫn chi tiết này.</p>
                    <a  (click)="openDialog('getting-started')" class="btn btn-primary">Đọc Thêm</a>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="card">
                <div class="card-header bg-success text-white">
                    Câu Hỏi Thường Gặp
                </div>
                <div class="card-body">
                    <p class="card-text">Tìm câu trả lời cho các câu hỏi thường gặp nhất.</p>
                    <a (click)="openDialog('faq')" class="btn btn-success">Đọc Thêm</a>
                </div>
            </div>
        </div>

        <div class="col-md-4">
            <div class="card">
                <div class="card-header bg-warning text-white">
                    Liên Hệ Hỗ Trợ
                </div>
                <div class="card-body">
                    <p class="card-text">Cần hỗ trợ thêm? Liên hệ với đội ngũ hỗ trợ của chúng tôi.</p>
                    <a (click)="openDialog('contact')" class="btn btn-warning">Liên Hệ</a>
                </div>
            </div>
        </div>
    
    </div>

    <div class="row mt-4">
        <div class="col-md-4">
            <div class="card">
                <div class="card-header bg-dark text-white">
                    Cài Đặt Cục Bộ
                </div>
                <div class="card-body">
                    <p class="card-text">Hướng dẫn cài đặt ứng dụng trên máy cục bộ.</p>
                    <a (click)="openDialog('local-installation')" class="btn btn-dark">Đọc Thêm</a>
                </div>
            </div>
        </div>
    
        <div class="col-md-4">
            <div class="card">
                <div class="card-header bg-light text-dark">
                    Cài Đặt Từ Xa
                </div>
                <div class="card-body">
                    <p class="card-text">Hướng dẫn thiết lập ứng dụng trên máy chủ từ xa.</p>
                    <a (click)="openDialog('remote-installation')" class="btn btn-light">Đọc Thêm</a>
                </div>
            </div>
        </div>
    
        <div class="col-md-4">
            <div class="card">
                <div class="card-header bg-primary text-white">
                    Yêu Cầu Máy Chủ
                </div>
                <div class="card-body">
                    <p class="card-text">Kiểm tra các yêu cầu máy chủ cần thiết trước khi cài đặt.</p>
                    <a (click)="openDialog('server-requirements')" class="btn btn-primary">Đọc Thêm</a>
                </div>
            </div>
        </div>

       
    </div>

    <div class="row mt-4">
        <div class="col-md-4">
            <div class="card">
                <div class="card-header bg-danger text-white">
                    Nhật Ký Thay Đổi
                </div>
                <div class="card-body">
                    <p class="card-text">Xem các cập nhật và thay đổi mới nhất trong ứng dụng.</p>
                    <a (click)="openDialog('changelog')" class="btn btn-danger">Đọc Thêm</a>
                </div>
            </div>
        </div>
    </div>
    

    <hr class="my-5">

    <h2 class="mt-4">Các Phần Mô-đun</h2>
    <ul class="list-group mt-3">
        <li class="list-group-item"><a (click)="openDialog('catalog')">Danh Mục</a></li>
        <li class="list-group-item"><a (click)="openDialog('member')">Thành Viên</a></li>
        <li class="list-group-item"><a (click)="openDialog('circulation')">Lưu Thông</a></li>
        <li class="list-group-item"><a (click)="openDialog('overdue')">Quá Hạn</a></li>
        <li class="list-group-item"><a (click)="openDialog('budget')">Ngân Sách</a></li>
        <li class="list-group-item"><a (click)="openDialog('notice')">Thông Báo</a></li>
        <li class="list-group-item"><a (click)="openDialog('author')">Tác Giả</a></li>
        <li class="list-group-item"><a (click)="openDialog('media-type')">Loại Phương Tiện</a></li>
        <li class="list-group-item"><a (click)="openDialog('member')">Thành Viên</a></li>
        <li class="list-group-item"><a (click)="openDialog('purshase-suggestion')">Gợi Ý Mua Sắm</a></li>
    </ul>

    <footer class="mt-5 text-center">
        <p>&copy; 2024 Công Ty Của Bạn. Bảo lưu mọi quyền.</p>
    </footer>
</div>


